"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTooLargeNumber = exports.isNumber = exports.isNumberOrNull = exports.numberOrNullTest = exports.moneyOptionalValidate = exports.moneyValidate = exports.precision = void 0;
var tslib_1 = require("tslib");
var bignumber_js_1 = tslib_1.__importDefault(require("bignumber.js"));
var yup = tslib_1.__importStar(require("yup"));
/**
 * Returns a validator function that tests how much decimal places a value has.
 * Used by yup library for custom testing
 *
 * @param {number} places number of decimal places allowed
 */
function precision(places) {
    /**
     * validation function
     *
     * @param {number} value value to test for decimal places
     * @returns {boolean} is the number of decimal places less or equal to the limit
     */
    return function (value) {
        // empty value should be considered true, let the other validators check if required
        if (!value)
            return true;
        return new bignumber_js_1.default(value).decimalPlaces() <= places;
    };
}
exports.precision = precision;
/**
 * Use this to validate required money input,
 * or number input where decimals are allowed
 */
function moneyValidate(errorMessage) {
    if (errorMessage === void 0) { errorMessage = 'Value must be a valid number (e.g. 32.20)'; }
    return yup
        .mixed()
        .test('two-decimal-places', errorMessage, precision(2))
        .test('is-number', errorMessage, isNumber)
        .test('is-too-large-number', 'Cannot set a value larger than 1.000.000.000.000,00', isTooLargeNumber);
}
exports.moneyValidate = moneyValidate;
/**
 * Use this to validate money input,
 * or number input where decimals are allowed.
 * Also allows empty values
 */
function moneyOptionalValidate(errorMessage) {
    if (errorMessage === void 0) { errorMessage = 'Value must be a valid number (e.g. 32.20) or empty'; }
    return yup
        .mixed()
        .test('two-decimal-places', errorMessage, precision(2))
        .test('is-number-or-null', errorMessage, isNumberOrNull)
        .test('is-too-large-number', 'Cannot set a value larger than 1.000.000.000.000,00', isTooLargeNumber);
}
exports.moneyOptionalValidate = moneyOptionalValidate;
function numberOrNullTest(errorMessage) {
    return yup.mixed().test('number-or-null', errorMessage, isNumberOrNull);
}
exports.numberOrNullTest = numberOrNullTest;
function isNumberOrNull(value) {
    if (value === null || value === '')
        return true;
    return isNumber(value);
}
exports.isNumberOrNull = isNumberOrNull;
function isNumber(value) {
    // will return null for invalid numbers
    // will return 0 for integers
    // will return number of decimal places for floating numbers
    return new bignumber_js_1.default(value).decimalPlaces() !== null;
}
exports.isNumber = isNumber;
/**
 * Check wether the passed value is larger than 1 thrillion.
 * If it's not a number then just ignore it, let other validation take care of it.
 */
function isTooLargeNumber(value) {
    var numericValue = parseFloat(value);
    if (Number.isNaN(numericValue))
        return true;
    var THRILLION = 1000000000000;
    return numericValue <= THRILLION;
}
exports.isTooLargeNumber = isTooLargeNumber;
